import { create } from 'zustand';
import type { PlaybackState } from './playbackState';
import { createPlaybackSlice } from './slices/playbackSlice';

export const usePlaybackStore = create<PlaybackState>()((set, get) => ({
  ...createPlaybackSlice(set, get),
}));
